import React from "react";
import { themeStyle, themeStyleDark } from "../components/Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { Link, Navigate, useNavigate } from "react-router-dom";
import CountUp from "react-countup";

export default function Benchmark() {
  const state = useSelector((state) => state);

  return (
    <div
      className="aboutabout4"
      style={{
        backgroundColor: "#000c66",
        color:
          state.auth.theme == "dark"
            ? themeStyleDark.primaryButtonTextColor
            : themeStyle.primaryButtonTextColor,
      }}
    >
      <div
        style={{
          fontSize: state.auth.isMobile ? "30px" : "40px",
          fontWeight: "bold",
          fontFamily: "Montserrat",
        }}
      >
        Setting Benchmark in Quality Education
      </div>
      <br />
      <br />
      <Grid container spacing={2.5} style={{ width: "80%" }}>
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <div className="icard" style={{ backgroundColor: "white" }}>
            <CountUp
              end={16}
              duration={10}
              onEnd={() => {}}
              style={{
                fontFamily: "Montserrat",
                fontSize: state.auth.isMobile ? "40px" : "80px",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                marginTop: state.auth.isMobile ? "10px" : "-10px",
                paddingBottom: "20px",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
              }}
            >
              Buses
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <div className="icard" style={{ backgroundColor: "white" }}>
            <CountUp
              end={45}
              duration={10}
              onEnd={() => {}}
              style={{
                fontFamily: "Montserrat",
                fontSize: state.auth.isMobile ? "40px" : "80px",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                marginTop: state.auth.isMobile ? "10px" : "-10px",
                paddingBottom: "20px",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
              }}
            >
              Teachers
            </div>
          </div>
        </Grid>{" "}
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <div className="icard" style={{ backgroundColor: "white" }}>
            <CountUp
              end={300}
              duration={10}
              onEnd={() => {}}
              style={{
                fontFamily: "Montserrat",
                fontSize: state.auth.isMobile ? "40px" : "80px",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                marginTop: state.auth.isMobile ? "10px" : "-10px",
                paddingBottom: "20px",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
              }}
            >
              Hostel Capacity
            </div>
          </div>
        </Grid>{" "}
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <div className="icard" style={{ backgroundColor: "white" }}>
            <CountUp
              end={950}
              duration={10}
              onEnd={() => {}}
              style={{
                fontFamily: "Montserrat",
                fontSize: state.auth.isMobile ? "40px" : "80px",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                marginTop: state.auth.isMobile ? "10px" : "-10px",
                paddingBottom: "20px",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
              }}
            >
              Students
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
